
import Vue from 'vue';
import ListMenuItem from '../components/ListMenuItem.vue';
import { ENDPOINTS } from '../settings/endpoints';
import { UserModel } from '@descomplica/dex-models';

interface MenuItenResult {
  label: string;
  onClickHandler: () => void;
}

interface Data {
  pearsonURL: string | undefined;
}

export default Vue.extend({
  components: {
    ListMenuItem,
  },
  data(): Data {
    return { pearsonURL: ENDPOINTS.pearson };
  },
  computed: {
    user(): UserModel {
      return this.$store.getters.currentUser;
    },
    menuItems(): MenuItenResult[] {
      return [
        {
          label: 'Acervo Digital Pearson',
          onClickHandler: () => {
            (this.$refs.pearsonSubmit as HTMLBaseElement).click();
          },
        },
        // It was commented to deliver what was requested in this story: https://app.clubhouse.io/teamregulados/story/1287
        // {
        //   label: 'Acervo Digital Saraiva',
        //   onClickHandler: () => {
        //     window.readerAccess(saraivaId, `${this.user.id}`, saraivaId);
        //   },
        // },
      ];
    },
  },
});
